import { render, staticRenderFns } from "./vm-google.vue?vue&type=template&id=0cc67f7c&scoped=true&lang=pug&"
import script from "./vm-google.vue?vue&type=script&lang=js&"
export * from "./vm-google.vue?vue&type=script&lang=js&"
import style0 from "./vm-google.vue?vue&type=style&index=0&id=0cc67f7c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc67f7c",
  null
  
)

export default component.exports